import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";


@Component({
  templateUrl: "./terms-dialog.component.html",
  selector: "app-terms",
  providers: [BsModalService]
})


export class TermsDialogComponent implements OnDestroy, OnInit{
  // data: { message: string };
  // private errorSub: Subscription;
  //   @Input() title: string = 'Modal with component';
  //   @Input() message: string = 'Message here...';
    @Input() data: any = {};
    @Output() action = new EventEmitter();
    buttonAction = false;
    termsHtml= '';
    isShowCircle: boolean = true;


  constructor(public bsModalRef: BsModalRef, private http: HttpClient) {
      this.buttonAction = false;
  }

  ngOnInit(){
      // console.log('data', this.data);
      const self= this;
      this.getTermsValue(self.data.code).subscribe(postData => {
          self.isShowCircle = false;
          if (postData['template']) {
              self.termsHtml = postData['template'];
              window.dispatchEvent(new Event('resize'));
          }
      }, error1 => {
          self.isShowCircle = false;
      });
  }


  getTermsValue(code){
      return this.http.get<{
          message: string;
          messageId: string;
          extra: object;
      }>(environment.apiUrl +'/param/t-p?code='+code);
  }
  ngOnDestroy(){
      if (!this.buttonAction){
        this.action.emit({backdropExit: true});
      }
  }
  clickOk() {
    // console.log("Click ok...");
    this.buttonAction = true;
    this.action.emit(true);
    this.bsModalRef.hide();
  }

  cancel() {
    this.buttonAction = true;
    this.bsModalRef.hide();
    this.action.emit(false);
  }
}
